import type { FC } from 'react';
import { Box, TextButton } from '@zillow/constellation-10';
import { tourCardSelectableControlsStyles } from '../styles';

interface TourCardSelectableControlsProps {
  isSelected: boolean;
  onView: () => void;
  onSelect: () => void;
}

const TourCardSelectableControls: FC<TourCardSelectableControlsProps> = ({ isSelected, onView, onSelect }) => (
  <Box css={tourCardSelectableControlsStyles}>
    <Box css={{ marginRight: '400' }}>
      <TextButton onClick={onView}>View</TextButton>
    </Box>
    <Box css={{ marginRight: '400' }}>
      <TextButton onClick={onSelect}>{isSelected ? 'Deselect' : 'Select'}</TextButton>
    </Box>
  </Box>
);

export type { TourCardSelectableControlsProps };
export default TourCardSelectableControls;
